module.exports = __webpack_public_path__ + "img/disconnected.5f98df19.png";